export default __webpack_public_path__ + "static/report-card-tracker-d3a0ef94cc4809265ab859320ae971a0.png";